export default __webpack_public_path__ + "static/media/9.c4d36930.jpg";